import Slider from '../helpers/Slider'

;(jQuery(function() {

	var page = {};
	page.features = $('.product-info__features');
	page.info = $('.product-info__aside');
	// page.info = $('.product-info');
	page.main = $('.product-info__main');

	var data = {};
	data.width = $(window).width();

	var action = {};
	action.switchBlocks = isMobile => {
		if (isMobile)
			page.features.appendTo(page.info);
		else
			page.features.appendTo(page.main);
	}
	action.decideToSwitchBlocks = () => {
		var newWidth = $(window).width();
		if (data.width < 768 && newWidth < 768) {
			data.width = newWidth;
			return;
		}
		if (data.width > 768 && newWidth > 768) {
			data.width = newWidth;
			return;
		}
		data.width = newWidth;
		if (data.width < 768)
			return action.switchBlocks(true);
		else
			return action.switchBlocks(false);
	}

	if (data.width < 768)
		action.switchBlocks(true);

	$(window).resize( action.decideToSwitchBlocks );

	$('.map-link__sub').click(function() {
		let newText = $(this).data('text');
		$(this).data('text', $(this).text());
		$(this).children().text(newText);

		if ($('#product_map').css('display') === 'none') {
			$('#product_map').slideDown(400, function() {
				if ($('#product_map').html() === '')
					mapInit();
			});
		} else {
			$('#product_map').slideUp();
		}
	});

	$('.tabs__tab[data-tab="damages"]').click(function() {
		var slider = $(this).parents('.tabs').find('.tabs__block[data-tab="damages"]').find('.gallery__swiper');

		if (typeof window['swiper_' + slider.attr('id')] != 'undefined')
			return;

		setTimeout(function() {
			new Slider(slider);
		}, 100);
	});

}));